export const baseURL = "https://api.infinitymultisolutions.com";

//export const baseURL = "http://localhost:8080";
